$(document).ready(function () {
    "use strict";

    // open menu on click
    $('.js_menuButton').on('click', function (e) {
        e.preventDefault();

        var body = $('body');

        body.toggleClass('slideOut');
        body.toggleClass('noScroll');
    });

    // close menu on click (button within menu)
    $('.js_closeMenu').on('click', function (e) {
        e.preventDefault();

        var body = $('body');

        body.removeClass('slideOut');
        body.removeClass('noScroll');
    });

    // add perfectScrollBar to allow menu to be scrollable
    $('.js_slideOutMenuWrap').perfectScrollbar();

    // handle simple close of menu (as flyoutWrap not used here)
    $('.heritage .flyoutTopMenu').on('click', function (e) {
        e.preventDefault();
        $('.hasFranchise.subNavigstion').slideFadeToggle();
    });

    // handle children menu open / close in slide out menu
    $('.js_slideOutMenuWrap li.hasChildren > a').on('click', function (e) {
        e.preventDefault();

        var parent = $(this).parent();

        parent.toggleClass('open');
        parent.find('.sub').slideFadeToggle();
    });

    // clone top level link in menu, so it's navigatable
    $('.js_slideOutMenu li.hasChildren > a').each(function () {
        var top_level_item = $(this).clone().addClass('js_clonedLink');
        top_level_item.prependTo($(this).parent().find('.sub').find('ul')).wrap('<li />');
    });
});